/* @flow */

export default {
  root: {
    transition: 'transform 0.2s ease-out',
  },
  'root-isHidden': {
    transform: 'translate3d(0, -100%, 0)',
  },
};
